export const addNotification = (notification) => ({
    type: 'ADD_NOTIFICATION',
    payload: notification
});

export const setNotification = (notifications) => ({
    type: 'SET_NOTIFICATIONS',
    payload: notifications
});

export const resetUnreadCount = () => ({
    type: 'RESET_UNREAD_COUNT'
});